const APPERSION = "2.0.8";
const APPHASH = "#9f23b0fde1bce22c28ac79ddfe142ea9ff96124e";

export const getApplicationVersion = () => {
  /*eslint-disable no-useless-concat*/
  if (APPERSION === "%APPLICATION" + "_" + "VERSION%") {
    return "dev-hot-reload";
  } else {
    return APPERSION;
  }
};
export const getApplicationHash = () => {
  if (APPHASH === "%APPLICATION" + "_" + "HASH%") {
    return "#dev-hot-reload";
  } else {
    return APPHASH;
  }
};
